import { JsonRpcProvider } from 'ethers';

const FREE_RPC_ENDPOINTS = [
  'https://rpc.ankr.com/eth/dec8e5317af4d9c8cb41cc5bfaef26700319860751215bc62794cd3cafdd691d',
  'https://ethereum.publicnode.com',
  'https://cloudflare-eth.com'
];

export const getRPCProvider = async () => {
  console.log('Getting RPC provider...');
  
  for (const endpoint of FREE_RPC_ENDPOINTS) {
    try {
      console.log(`Trying: ${endpoint}`);
      const provider = new JsonRpcProvider(endpoint);
      
      const networkPromise = provider.getNetwork();
      const timeoutPromise = new Promise((_, reject) => 
        setTimeout(() => reject(new Error('Timeout')), 3000)
      );
      
      await Promise.race([networkPromise, timeoutPromise]);
      console.log(`Connected to: ${endpoint}`);
      return provider;
    } catch (error) {
      console.log(`Failed: ${endpoint} - ${error.message}`);
    }
  }
  
  console.log('All RPCs failed, using fallback');
  return new JsonRpcProvider(FREE_RPC_ENDPOINTS[0]);
};
